
import Vue from 'vue';
import { routesNames, getRoutePath } from '@/router';
import SectionHeading from '@/components/general/utils/SectionHeading.vue';
import { IPartner } from '~/types/misc_data';

import MISC_DATA from '@/store/modules/MiscDataModule';

export default Vue.extend({
	name: 'OfficialPartners',

	components: { SectionHeading },

	mixins: [],

	props: {
		noHeader: {
			type: Boolean,
			default: false
		},

		hidePartnersWithoutLocation: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			routesNames: routesNames,
			getRoutePath: getRoutePath
		};
	},

	computed: {
		MISC_DATA: () => MISC_DATA,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},

		isExtraSmall(): boolean {
			return this.$vuetify.breakpoint.width < 415;
		},

		domain(): string {
			return this.$getDomain();
		},

		partners(): IPartner[] {
			let partners = this.MISC_DATA.partners as any;

			if (this.hidePartnersWithoutLocation) {
				partners = partners.filter((item: { url: string }) => item.url !== '');
			}

			return partners;
		},

		customCols() {
			const width = this.$vuetify.breakpoint.width;

			if (width <= 415) {
				return 6;
			} else if (width <= 600) {
				return 4;
			} else {
				return 3;
			}
		}
	}
});
